module.exports = __webpack_public_path__ + "img/img_01_retail@3x.2c87d060.png";